<template>
    <div>

    </div>
</template>
  
<script>
export default {
    name: 'App',

    data() {
        return {

        }
    },
    created() {
        console.log(111)
    },
    mounted() {
        console.log(encodeURIComponent(this.$route.query.token))
        if (encodeURIComponent(this.$route.query.token)) {
            // this.$store.commit('token', this.$route.query.token)
            // this.getMenus()
            // this.getUserInfo()
            let data = {
                loginString: encodeURIComponent(this.$route.query.token)
            }
            console.log(data)
            this.axios.post('/sys/sysLogin', data)
                .then(res => {
                    console.log(res)
                    if (res.code == 0) {
                        this.$store.commit('token', res.data.token)
                        let userName = res.data.roleName + ' ' + res.data.username
                        sessionStorage.setItem('userName', JSON.stringify(userName))
                        sessionStorage.setItem('platformType', res.data.platformType)
                        this.getMenus()
                        this.getUserInfo()
                    }
                    // this.getCode()
                })
        }
    },
    methods: {
        getUserInfo() {
            this.axios.post('/sys/getUserInfo')
                .then(res => {
                    console.log(res)
                    if (res.code == 0) {
                        sessionStorage.setItem('userInfo', JSON.stringify(res.data))
                    }
                })
        },
        limits(menu) {
            let data = {
                menuTreeList: menu
            }
            sessionStorage.setItem('limit', JSON.stringify(data))
            this.$router.replace('home/welcome')
            // this.axios
            //   .get('/sys/v1/menu/button/user/tree?winType=' + this.loginForm.system, {
            //     headers: {
            //       isLoading: false
            //     }
            //   })
            //   .then((res) => {
            //     if (res.code == 0) {
            //       sessionStorage.setItem('limit', JSON.stringify(res.data))
            //       if (res.data.menuTreeList) {
            //         console.log(res)
            //         const juade = res.data.menuTreeList.find(
            //           (res) => res.code == 'index'
            //         )
            //         if (this.loginForm.system == '2') {
            //           this.$router.replace('dashboard')
            //         } else {
            //           console.log(juade, 'juade')
            //           if (juade) {
            //             // this.$router.replace('home')
            //             this.$router.replace('home/welcome') // 如果没有配置菜单权限就跳到欢迎页面
            //           } else {
            //             if (res.data.menuTreeList[0].children) {
            //               this.$router.replace(res.data.menuTreeList[0].children[0].jumpUrl)
            //             } else {
            //               this.$router.replace(res.data.menuTreeList[0].jumpUrl)
            //             }
            //           }
            //         }
            //       } else {
            //         this.$message({ type: 'warning', message: res.message })
            //       }
            //     } else {
            //       if (res.code == 103) {
            //         this.$router.replace('home/welcome') // 如果没有配置菜单权限就跳到欢迎页面
            //       }
            //       // this.$message({ type: "warning", message: res.message });
            //     }
            //   })
        },
        //获取菜单列表接口
        getMenus() {
            this.axios.get('/sys/menus')
                .then(res => {
                    console.log(res)
                    if (res.code == 0) {
                        let iconList = [
                            'icon_yonghuguanli@2x',
                            'icon_shanpin@2x',
                            'icon_dingdan@2x',
                            'icon_caiwu@2x',
                            'icon_xitong@2x',
                            'icon_shangcheng@2x',
                            'icon_yingxiao@2x'
                        ]
                        // res.data.splice(res.data.length-1,1)
                        res.data.forEach((item, index) => {
                            item.iconUrl = iconList[index]
                        })
                        this.limits(res.data)
                    }

                })
        },
    }
}
</script>
  
<style></style>
  